import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { AppComponent } from './app/app.component';
import { routes } from './app/app.routes';
import { mockApiInterceptor } from './app/core/interceptors/mock-api.interceptor';
import { httpErrorInterceptor } from './app/kiosk/core/interceptors/http-error.interceptor';
import { AuthInterceptor } from './app/services/auth.interceptor';
import { adminAuthInterceptor } from './app/services/admin-auth.interceptor';
import { TrialInterceptor } from './app/services/trial.interceptor';
import { provideServiceWorker } from '@angular/service-worker';
import {
  isDevMode,
  ErrorHandler,
  LOCALE_ID,
  APP_INITIALIZER,
  provideZonelessChangeDetection,
} from '@angular/core';
import { GlobalErrorHandlerService } from './app/kiosk/services/global-error-handler.service';
import { AnalyticsService } from './app/services/analytics.service';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';

// Enregistrer la locale française
registerLocaleData(localeFr);

function initMatomo(analytics: AnalyticsService): () => void {
  return () => analytics.init();
}

bootstrapApplication(AppComponent, {
  providers: [
    provideZonelessChangeDetection(),
    provideRouter(routes),
    // 🎭 Mock API doit être AVANT AuthInterceptor pour intercepter les requêtes en premier
    provideHttpClient(
      withInterceptors([
        mockApiInterceptor,
        AuthInterceptor,
        adminAuthInterceptor,
        httpErrorInterceptor,
        TrialInterceptor,
      ]),
    ),
    provideAnimations(),
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000',
    }),
    // ✅ Sprint 1 Extension: Global Error Handler
    { provide: ErrorHandler, useClass: GlobalErrorHandlerService },
    // 🌍 Locale française par défaut
    { provide: LOCALE_ID, useValue: 'fr-FR' },
    // 📊 Matomo Analytics init
    {
      provide: APP_INITIALIZER,
      useFactory: initMatomo,
      deps: [AnalyticsService],
      multi: true,
    },
  ],
}).catch((err: Error) => console.error(err));
